module.exports = __webpack_public_path__ + "static/img/history.25df23e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/history.png
// module id = RI1/
// module chunks = 0